import { DateTime as DT } from 'luxon';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CopyTextWrapper from 'components/others/CopyTextWrapper';
import ClientAction from './ClientsRows/ClientAction';

interface ClientTableRowProps {
    client: any;
    fetchClients: (force?: boolean) => Promise<void>;
    setEditClientId: (clientId: number) => void;
    setInfoClientId: (clientId: number) => void;
}

const ClientTableRow = ({ client, fetchClients, setEditClientId, setInfoClientId }: ClientTableRowProps) => {
    const { t } = useTranslation(['Clients']);
    const dtC = DT.fromMillis(client?.clientCreated || 0).toLocaleString(DT.DATE_MED);

    return (
        <tr>
            <td className="name">
                <Col>
                    <h6
                        className="mb-1 text-break cursor-pointer"
                        onClick={() => setEditClientId(client.ID)}
                    >
                        {client.clientName || '-'}
                    </h6>
                    <p className="text-muted f-12 mb-0 my-1">{client.clientPhone || '-'}</p>
                </Col>
            </td>
            <td className="email text-break">
                <CopyTextWrapper value={client.clientEmail || ''} wrap>
                    <span>{client.clientEmail || '-'}</span>
                </CopyTextWrapper>
            </td>
            <td className="status">
                <span className={`badge ${client.clientStatus === 0 ? 'bg-success' : 'bg-secondary'}`}>
                    {client.clientStatus === 0 ? t('status.0') : t('status.1')}
                </span>
            </td>
            <td className="leads-count">{client.leadsCount || 0}</td>
            <td className="updated">{dtC}</td>
            <td className="action">
                <ClientAction
                    client={client}
                    fetchClients={fetchClients}
                    setEditClientId={setEditClientId}
                    setInfoClientId={setInfoClientId}
                />
            </td>
        </tr>
    );
};

export default ClientTableRow;
